var m = require('mithril');
var prop = require('mithril/stream')
var R = require('ramda');
var loaders = require('../layout/components/loaders');
var flash = require('../components/flash');
var modelBase = require('../../../../models/Model');
var textInput = require('../components/inputs/textInput');
var textAreaInput = require('../components/inputs/textAreaInput');
var numberInput = require('../components/inputs/numberInput');
var selectInput = require('../components/inputs/selectInput');
var dateInput = require('../components/inputs/dateInput');
var fileInput = require('../components/inputs/fileInput');
var passwordInput = require('../components/inputs/passwordInput');
var switchInput = require('../components/inputs/switchInput');

var apiPrefix = '/api/v1/';

var fieldTypes = {
  text: textInput,
  textarea: textAreaInput,
  number: numberInput,
  select: selectInput,
  date: dateInput,
  file: fileInput,
  password: passwordInput,
  switch: switchInput
};

var Model = {};

Object.assign(Model, modelBase);

function rejectFailedResponse(response) {
  if (response && response.ok) {
    return response;
  }

  return response.text()
  .then(function (text) {
    var error = text || (response && response.statusText) || 'Request failed';
    try {
      error = JSON.parse(text);
    } catch (e) {}
    return Promise.reject(error);
  });
}

function setFormErrors(model, errors) {
  if (Array.isArray(errors)) {
    model.errors = errors;
  } else if (typeof errors === 'object' && errors && errors.error && typeof errors.error === 'string') {
    model.errors = [errors.error];
  } else if (typeof errors === 'string') {
    model.errors = [errors];
  } else {
    model.errors = ['Request failed'];
  }
}

Model.initForm = function (record) {
  var self = this;

  self.record = record || {};
  self.errors = [];
  self.successes = [];

  var setFields = R.compose(R.map(prop), R.merge(R.map(R.propOr(null, 'default'), self.fields)));
  self.form = setFields(R.clone(self.record));
};

Model.getUrl = function (record) {
  return apiPrefix + this.url + '/' + record['@rid'].slice(1);
};

Model.save = function () {
  var self = this;
  var reqPromise;

  if (self.isMultipart) {
    reqPromise = Model.saveMultipart.call(self);
  } else {
    reqPromise = Model.saveJSON.call(self);
  }

  return reqPromise;
}

Model.saveJSON = function () {
  var self = this;
  var formData = {};
  
  Object.keys(self.fields).forEach(function (key) {
    if (key == 'in' || key == 'out') {
      if (self.form[key]() && self.form[key]['@rid']) {
        return formData[key] = self.form[key]()['@rid'];
      }
    }
    formData[key] = self.form[key].toJSON();
  })
  
  return self.validate(self.form)
  .then(function () {
    self.errors = [];
    if (self.record && self.record['@rid']) {
      return loaders.requestWithLoader({
        loader: 'submit',
        url: self.getUrl(self.record),
        method:'PUT',
        body: formData
      })
    } else {
      if (self.isMultipart) {
        return fetch('/api/v1/' + self.url, {method: "POST", body: formData});
      } else {
        return loaders.requestWithLoader({
          loader: 'submit',
          url: '/api/v1/' + self.url,
          method:'POST',
          body: formData
        })
      }
    }
  })
  .catch(function (errors) {
    if(Array.isArray(errors)) self.errors = errors;
    if(typeof errors === 'object' && errors.error && typeof errors.error === 'string') self.errors = [errors.error];
    if(typeof errors === 'string')  self.errors = [errors];
    m.redraw();
    return Promise.reject(errors);
  })
};


Model.saveMultipart = function () {
  var self = this;
  var formData = new FormData();
  
  Object.keys(self.fields).forEach(function (key) {
    if (key == 'in' || key == 'out') {
      if (self.form[key]()['@rid']) {
        return formData.append(key, self.form[key]()['@rid']);
      }
    }
    formData.append(key, self.form[key]());
  })
  
  return self.validate(self.form)
  .then(function () {
    self.errors = [];
    if (self.record['@rid']) {
      return fetch('/api/v1/' + self.url, {method: "PUT", body: formData})
      .then(rejectFailedResponse);
    } else {
      return fetch('/api/v1/' + self.url, {method: "POST", body: formData})
      .then(rejectFailedResponse);
    }
  })
  .catch(function (errors) {
    setFormErrors(self, errors);
    m.redraw();
    return Promise.reject(errors);
  })
};

Model.delete = function (record) {
  return loaders.requestWithLoader({
    loader: 'submit',
    url: this.getUrl(record),
    method: 'DELETE'
  });
};

Model.increment = function (record) {
  return loaders.requestWithLoader({
    loader: 'background',
    url: this.getUrl(record) + '/increment',
    method: 'PUT'
  });
};

Model.decrement = function (record) {
  return loaders.requestWithLoader({
    loader: 'background',
    url: this.getUrl(record) + '/decrement',
    method: 'PUT'
  });
};

Model.errorView = function () {
  return m('div', {
    style: {
      position: 'sticky',
      top: '0',
    }
  }, [
    m(flash, {items:this.errors, bg: 'bg-red'})
  ]);
};

Model.successView = function () {
  return m(flash, {items:this.successes, bg: 'bg-green'});
};

Model.urlForRecord = function (record) {
  return '/api/v1/' + record['@class'].toLowerCase() + '/' + record['@rid'].slice(1);
};

Model.toJSON = function toJSON () {
  var self = this;
  var formData = {};

  Object.keys(self.fields).forEach(function (key) {
    formData[key] = self.form[key].toJSON();
  })

  return formData;
}

Model.toPOJO = function toJSON () {
  var self = this;
  var formData = {};

  Object.keys(self.fields).forEach(function (key) {
    var val = typeof self.form[key] === 'function' ? self.form[key]() : self.form[key];
    formData[key] = val;
  })

  return formData;
}

Model.serialize = function(obj) {
  return Object.keys(obj).map(function (p) {
    return encodeURIComponent(p) + "=" + encodeURIComponent(obj[p])
  }).join('&')
};

function camelize(str) {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (match === '0' && index === 0) return 0;
    if (+match === 0) return "";
    return index == 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

Model.view = function view (vnode) {
  var self  = this;

  // String -> String
  var titleCase = (str) => str.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
  // String, a, {k:v}) -> {k:v}
  var addKeyAsTitleCaseName = (value, key, obj) => R.assoc('name',  titleCase(key), value);
  // (a, b) -> VirtualElement
  var createFormField = R.curry(function (form, el) {
    return m(fieldTypes[el['type']], {field: el, prop: form[camelize(el.name)]})
  });
  // a -> [VirtualElement]
  var createForm = R.compose(R.map(createFormField(self.form)), R.filter(R.has('type')), R.values, R.mapObjIndexed(addKeyAsTitleCaseName));

  if (self.isMultipart) {
    return m('form',  {role:'form', enctype:'multipart/form-data', method: 'post'}, [
      self.errorView(),
      createForm(self.fields)
    ]);
  } else {
    return m('form', {role:'form', }, [
      self.errorView(),
      createForm(self.fields)
    ]);
  }
};

module.exports = Model;
